// extracted by mini-css-extract-plugin
module.exports = {"page-body":"MachineConfiguration_page-body__1R4hL","config-container":"MachineConfiguration_config-container__1rahy","side-panel":"MachineConfiguration_side-panel__3xw8e"};